import { useSyncExternalStore } from 'react';

const subscribe = () => () => {};

/**
 * Renders a component only on client to avoid rehydration issues.
 * https://joshwcomeau.com/react/the-perils-of-rehydration/
 */
export default function ClientOnly({ children }) {
  const isClient = useSyncExternalStore(
    subscribe,
    () => true,
    () => false
  );

  return isClient ? children : null;
}
